import React from 'react';
import Apointment from '../../Apointment/Apointment';
import Banner from '../Banner/Banner';
import Contactus from '../Contactus/Contactus';
import InfoCards from '../InfoCards/InfoCards';
import Services from '../Services/Services';
import Testimonial from '../Testimonial/Testimonial';
import Treatment from '../Treatment/Treatment';

const Home = () => {
    return (
        <div className='mx-5'>
           <Banner></Banner>
           <InfoCards></InfoCards>
           <Services></Services>
           <Treatment></Treatment>
           <Apointment></Apointment>
           <Testimonial></Testimonial>
           <Contactus></Contactus>
            
        </div>
    );
};

export default Home;